import React, { useEffect, useState, useRef } from 'react'
import { Row, Col, Tabs, Card, Button, Form, Table } from 'antd';
import { connect } from 'react-redux'
import SalaryPrintFilter from './SalaryPrintFilter';
import './index.scss'
import {
  CycleIco,
  NavigationLeftIco,
  TabsInfoIco,
} from '../../../../../modules/CustomIcons'
import moment from 'moment'
import TableComponent from 'components/Table'
import SortableColumn from 'components/Table/ColumnSort'
import CustomTooltip from 'components/Tooltip'
import SelectField from 'components/SelectField'
import SearchableColumn from 'components/Table/ColumnSearch'
import SalaryPrintInfo from './SalaryPrintInfo'
import { getBusinessDate } from '../../../../../app/services/transfers'
import SalaryPrintFooter from './SalaryPrintFooter'
import { financial, dateFormatter } from '../../../../services/helper';
import { AccountsStatement } from '../../../../services/account';
import { Spinner } from "constants/constants";
import { getAccountStatementData } from '../../../../store/actions/accountStatement';
import { useActions } from 'hooks/useActions';
import { getCurrentCompany } from '../../../../services/user';
import FullScreenLoading from 'components/FullScreenLoading';
import { useTranslation } from 'react-i18next';
import { useConveyer } from "@egjs/react-conveyer";

const SalaryFilter: React.FC<any> = ({ accountsStatementData, inProgress, filterData }) => {

  const {t} = useTranslation()
  const ref = useRef<HTMLDivElement>(null);
  useConveyer(ref, {
    horizontal: true,
  });
  const [form] = Form.useForm()
  const { TabPane } = Tabs
  const [selectAccountOptions, setAccountOptions] = useState([])
  const [activeIndexDate, setDateIndex] = useState(1)
  const [businessDate, setBusinessDate] = useState('')
  const [tableData, setTableData] = useState<AccountsStatement[]>();
  const [tableListForSortOriginal, setTableListForSortOriginal] = useState<AccountsStatement[]>();
  const [tableDataMain, setTableDataMain] = useState<AccountsStatement[]>();
  const [tableLoading, setTableLoading] = useState(Spinner);
  const [tranzitaccForNotif, SetTranzitaccForNotif] = useState(null);
  const language = localStorage.getItem("i18nextLng")
  const [endDate, setEndDate] = useState(moment())
 const [startDate, setStartDate] = useState()
 
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
  });

  const { getAccountStatementData } = useActions();

  const pageOptions = [50, 200, 1000]

  const dateFilter = [
    {
      label: t("common.all"),
      value: 0,
    },
    {
      label: '10.11.2021',
      value: '10.11.2021',
    },
    {
      label: '12.12.2021',
      value: '12.12.2021',
    },
  ]

  const getBussinessDateData = async () => {
    const bussinesDate = await getBusinessDate(language)
    setBusinessDate(bussinesDate)
    setEndDate(moment(bussinesDate, "DD.MM.YYYY"))

  }

  useEffect(() => {
    getBussinessDateData()
  }, [])

  const [filtereValues, setFilteredValues] = useState({ "col_2": "", "col_3": "", "col_4": "" })

  const handleFilterColumn = (e: any, column: string) => {

    let newfiltereValues = filtereValues;


    if (column === 'col_2') {
      newfiltereValues.col_2 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'col_3') {
      newfiltereValues.col_3 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'col_4') {
      newfiltereValues.col_4 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }


    if (tableDataMain && filtereValues) {

      let filteredData: any;

      filteredData = tableDataMain?.filter((sRow: any) => (sRow.col_2 ? sRow.col_2?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_2"]) : filtereValues["col_2"] === '' ? sRow.col_2 === null : "") && (sRow.col_3 ? sRow.col_3?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_3"]) : filtereValues["col_3"] === '' ? sRow.col_3 === null : "") && (sRow.col_4 ? sRow.col_4?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_4"]) : filtereValues["col_4"] === '' ? sRow.col_4 === null : ""));

      setTableData(old_data => filteredData);
      setTableListForSortOriginal(old => filteredData)
      setPagination({
        ...pagination,
        current: 1
      })

    }
  }

  const columnsData = [
    {
      title: (
        <div className="flex">
          <SortableColumn
            data={tableData}
            setData={setTableData}
            dataOriginal={tableListForSortOriginal}
            type={"date"}
            parameter={"col_1"}
            paramater_second={"date"}
            hasTime={true}
          />
          <p>{t("common.date")}</p>
          {/* <CustomTooltip
            className="table-tooltip date-tooltip"
            title="Statusun əldə olunması tarixi"
            placement="top"
          >
            {' '}
            <Form form={form}>
              <SelectField
                placeholder={'Tarix'}
                width={95}
                options={dateFilter}
                className="status-select"
                name={'date_filter'}
                onChange={(value: string | number) =>
                  console.log('value===>>', value)
                }
              />
            </Form>
          </CustomTooltip> */}
        </div>
      ),
      dataIndex: 'col_1',
      key: 'col_1',
      className: 'date',
      render: (data) => (
        <>
          <p>{data.date}</p>
        </>
      ),
      ellipsis: true,
      width: 89,
      editable: false,
    },
    {
      title: (
        <div className="searchable-column">
          <div className={'flex'}>
            <Form
              form={form}
            >
              <SearchableColumn
                form={form}
                name={"operation_number"}
                filter={"searchfilter"}
                title={t("accountStatement.transactionNumber")}
                onChange={(event: any) => handleFilterColumn(event, 'col_2')}
              />
            </Form>
            {/* <SearchableColumn title={t("accountStatement.transactionNumber")} /> */}
          </div>
        </div>
      ),
      dataIndex: 'col_2',
      key: 'col_2',
      width: 181,
      ellipsis: true,
      editable: false,
      className: 'col_2 ant-table-cell-ellipsis',
      render: (text: string) => (
        <>
          <p style={{ minWidth: 140, textAlign: "left" }}>{text}</p>
        </>
      ),
    },
    {
      title: (
        <div className="searchable-column">
          <div className={'flex'}>
            <Form
              form={form}
            >
              <SearchableColumn
                form={form}
                name={"sender_getter"}
                filter={"searchfilter"}
                title={t("home.senderReceiver")}
                onChange={(event: any) => handleFilterColumn(event, 'col_3')}
              />
            </Form>
            {/* <SearchableColumn title={'Göndərən/Alan'} /> */}
          </div>
        </div>
      ),
      dataIndex: 'col_3',
      key: 'col_3',
      maxWidth: 181,
      ellipsis: true,
      editable: false,
      render: (text: string) => {
        return text?.length > 30 ? (
          <CustomTooltip className="table-tooltip" title={text}>
            <p style={{ minWidth: 140, maxWidth: 330 }}>{text}</p>
          </CustomTooltip>
        ) : (
          <p style={{ minWidth: 140 }}>{text}</p>
        )
      },
    },
    {
      title: (
        <div className="searchable-column">
          <div className={'flex'}>
            <Form
              form={form}
            >
              <SearchableColumn
                form={form}
                name={"patment_description"}
                filter={"searchfilter"}
                title={t("accountStatement.paymentDetails")}
                onChange={(event: any) => handleFilterColumn(event, 'col_4')}
              />
            </Form>
            {/* <SearchableColumn title={t("accountStatement.paymentDetails")} /> */}
          </div>
        </div>
      ),
      dataIndex: 'col_4',
      key: 'col_4',
      width: 181,
      ellipsis: true,
      editable: false,
      render: (text: string) => {
        return text?.length > 30 ? (
          <CustomTooltip className="table-tooltip" title={text}>
            <p style={{ minWidth: 140 }}>{text}</p>
          </CustomTooltip>
        ) : (
          <p style={{ minWidth: 140 }}>{text}</p>
        )
      },
    },
    {
      title: (
        <div className={'flex justify_end'}>
          <SortableColumn
            data={tableData}
            setData={setTableData}
            dataOriginal={tableListForSortOriginal}
            type={"number"}
            parameter={"col_5"}
          />
          <p>{t("home.credit")}</p>
        </div>
      ),
      dataIndex: 'col_5',
      key: 'col_5',
      width: 181,
      ellipsis: true,
      editable: false,
      render: (data: string) => {
        let p_classname = parseFloat(data) > 0 ? 'is_blue' : 'is_grey';
        return (
          <>
            <p className={`flex align_center justify_end ${p_classname}`}>{data}</p>
          </>
        )
      },
    },
    {
      title: (
        <div className={'flex justify_end'}>
          <SortableColumn
            data={tableData}
            setData={setTableData}
            dataOriginal={tableListForSortOriginal}
            type={"number"}
            parameter={"col_6"}
          />
          <p>{t("home.debit")}</p>
        </div>
      ),
      dataIndex: 'col_6',
      key: 'col_6',
      width: 181,
      ellipsis: true,
      editable: false,
      render: (data: string) => {
        let p_classname = parseFloat(data) > 0 ? 'is_red' : 'is_grey';
        return (
          <>
            <p className={`flex align_center justify_end ${p_classname}`}>{data}</p>
          </>
        )
      },
    },
    {
      title: (
        <div className={'flex justify_end'}>
          <SortableColumn
            data={tableData}
            setData={setTableData}
            dataOriginal={tableListForSortOriginal}
            type={"number"}
            parameter={"col_7"}
          />
          <p>{t("accountStatement.balance")}</p>
        </div>
      ),
      dataIndex: 'col_7',
      key: 'col_7',
      width: 181,
      ellipsis: true,
      editable: false,
      render: (data: string) => {
        // let p_classname = parseFloat(data) > 0 ? 'is_red' : 'is_grey';
        return (
          <>
            <p className={`flex align_center justify_end`}>{data}</p>
          </>
        )
      },
    },
  ]

  const handleDateData = (key: number,startDate:any,endDate:any) => {
    setDateIndex(key)
    console.log(startDate,endDate)
    setEndDate(moment(endDate,'DD.MM.YYYY'))
    setStartDate(moment(startDate,'DD.MM.YYYY'))
  }

  useEffect(() => {
    // setTableLoading({
    //   ...tableLoading,
    //   spinning: false
    // });

    let temp_array = [];

    if (accountsStatementData.statementRows) {
      for (let row of accountsStatementData.statementRows) {

        // let tooltip_content = `${row.BRANCH_NAME}-da olan ${row.PRODUCT_NAME}`;
        // tooltip_content += `<br/>Yeni IBAN: ${row.IBAN}`;
        // tooltip_content += `<br/>Köhnə IBAN: ${row.ORJ_IBAN ?? '-'}`;

        // let col_6_class_name = '';

        // if (parseFloat(row.WFA_AMOUNT) > 0) {
        //   col_6_class_name = 'is_blue';

        // } else if (parseFloat(row.WFA_AMOUNT) < 0) {

        //   col_6_class_name = 'is_red';
        // }

        let create_date = dateFormatter(`${row.transactionDate} ${row.transactionTime}`);

        // @ts-ignore
        temp_array.push({
          // key: row.ACCOUNT_NO,
          col_1: { date: create_date },
          col_2: row.transactionRef,
          col_3: row.counterCustomerName,
          col_4: row.description,
          col_5: financial(row.amountCr),
          col_6: financial(row.amountDr),
          col_7: financial(row.balanceAmount),
        });
      }


      setTableData(old_data => temp_array);
      setTableListForSortOriginal(old_data => temp_array)
      setTableDataMain(old_data => temp_array);

      const totalItem = (pagination.pageSize !== undefined ? pagination.pageSize * accountsStatementData.pageCount : 0);
      setPagination({
        ...pagination,
        total: totalItem
      })
    }


  }, [accountsStatementData])


  const infoData = {
    leftColumnData: [
      { title: t("salary.accountHolder"), value: getCurrentCompany().name, key: 'customerName' },
      { title: t("accountStatement.currencyCode"), value: accountsStatementData.ccyType, key: 'ccyType' },
      { title: t("requisites.taxID"), value: getCurrentCompany().organizationCode, key: 'taxNo' },
      { title: t("accountStatement.lasttransactionDate"), value: accountsStatementData?.lastTransactionDate ?? "", key: 'lastTransactionDate' },
    ],
    rightColumnData: [
      { title: t("accountStatement.startingBalance"), value: financial(accountsStatementData.startBalance), key: 'startBalance' },
      { title: t("accountStatement.creditTurnover"), value: financial(accountsStatementData.crBalance), key: 'crBalance' },
      { title: t("accountStatement.debitTurnover"), value: financial(accountsStatementData.drBalance), key: 'drBalance' },
      { title: t("accountStatement.closingBalance"), value: financial(accountsStatementData.endBalance), key: 'endBalance' },
    ],
  }


  const handleTableChange = (
    newPagination: any,
  ) => {

    // getAccountStatementData({ company: getCurrentCompany(), formData: filterData[0], paginationData: newPagination });

    setPagination({
      ...pagination,
      current: newPagination.current
    })
  };


  return (
    <div className='transfer_child_tabs' ref={ref}>
      <Col
        span={24}
        style={{ backgroundColor: '#fff', borderRadius: 10 }}
        className="account-statemant salary-statement"
      >
        <SalaryPrintFilter
          businessDate={businessDate}
          setPagination={setPagination}
          pageOptions={pageOptions}
          handleDateData={handleDateData}
          activeDateIndex={activeIndexDate}
          handleFilterByAccount={(account) => {}}
          pagination={pagination}
          endDate={endDate}
          currencyType={accountsStatementData.ccyType}
          SetTranzitaccForNotif={SetTranzitaccForNotif}
        />
        {
          tranzitaccForNotif !== "" ? <></> :
            <Row className='accountStatement-nodata-row' style={{ marginTop: "25px" }}>
              <Row className='accountStatement-nodata-row__text'>
                {t("transfers.informationNotAvailable")}
              </Row>
            </Row>
        }
        {
          accountsStatementData.length !== 0 ?
            <Col>
              <SalaryPrintInfo data={infoData} />
              <Col
                className="salary-transfer__table__divider accountStatement-table"
                style={{ minHeight: '500px' }}
              >
                {/* <div className="salary-transfer__table transfers-table">
            <Row style={{ justifyContent: 'space-between' }}></Row>
          </div> */}
                {/* <TableComponent
            className="transfer-table salary-table transfers-table__component home_account_opt_table"
            columns={columnsData}
            // onRow={(record, rowIndex) => {
            //   return {
            //     onClick: () => handleRowClick(record.key),
            //   }
            // }}
            // rowSelection={{
            //   selectedRowKeys,
            //   onChange: onSelectChange,
            //   columnWidth: 20,
            // }}
            // onClose={() => setModalVisibility(false)}
            // scroll={{ x: '100%' }}
            // data={tableList}
            pagination={true}
            // pageSize={pageSize}
            position="bottom center"
            alignment="center"
          /> */}

                {

                  (accountsStatementData.statementRows) ?
                    <Table
                      pagination={
                        {
                          pageSize: pagination.pageSize,
                          current: pagination.current,
                          onChange: handleTableChange,
                        }
                      }
                      // loading={tableLoading}
                      columns={columnsData}
                      dataSource={tableData}
                      // rowClassName={rowClassName}
                      className='transfer-table salary-table transfers-table__component home_account_opt_table account_statement_pagination'
                      scroll={{ x: true }}
                    // onChange={handleTableChange}
                    // onRow={(record, rowIndex) => {
                    //     return {
                    //         onClick: e => {

                    //             let status=
                    //                 e?.target?.classList?.contains('not_open_popup') ||
                    //                 e?.target?.classList?.contains('ant-table-column-title') ||
                    //                 e?.target?.classList?.contains('ant-btn') ||
                    //                 e?.target?.classList?.contains('anticon') ||
                    //                 e?.target?.tagName=='button' ||
                    //                 e?.target?.tagName=='svg' ||
                    //                 e?.target?.tagName=='path'
                    //                     ? false : true;

                    //             setRowModalVisible(status);
                    //         },
                    //     };
                    // }}
                    /> :
                    <Row className='accountStatement-nodata-row'>
                      <Row className='accountStatement-nodata-row__text'>
                      {t("accountStatement.noTransactionDuringPeriodNote")}
                      </Row>
                    </Row>
                }

              </Col>
              <SalaryPrintFooter startDate={startDate} endDate={endDate} tableData={accountsStatementData.statementRows} />
              {/* {
                accountsStatementData.statementRows ? <SalaryPrintFooter /> : <></>
              } */}

            </Col> : <Col
              className="salary-transfer__table__divider accountStatement-table"
              style={{ minHeight: '628px' }}
            ></Col>
        }
      </Col>
      {
        inProgress ? <FullScreenLoading /> : <></>
      }
    </div>
  )
}


const mapDispatchToProps = { getAccountStatementData }

const mapStateToProps = (state: any) => ({
  accountsStatementData: state.accountsStatement.accountsStatementData.result ?? [],
  inProgress: state.accountsStatement.inProgress,
  filterData: state.accountsStatement.filterData
})
export default connect(mapStateToProps, mapDispatchToProps)(SalaryFilter)